<template lang="pug">
.entry
  .cover
    .container
      h1 会员申请
      .observer-tip
        p
          | 「前沿社」是由极客公园发起创立的企业家社群
          br
          | 通过「近场研究FIELD STUDY」、「前沿工作坊FRONTIER WORKSHOP」、「超频之旅OVERCLOCKING TRIP」三大板块
          br
          | 帮助企业家把握技术潮流、连接产业前沿及保持创新思维
          br
          | 以最有效率的方式，让最优秀的企业家与全球顶尖科学家、科技研究者一起迭代进步。
      .link
        a(v-bind:href="link" target="_blank")
          | 立即申请
          .triangle-right
      //- .observer-tip
        p
          a.observer-link(href="/observer") 申请成为观察员 >
          br
          | 前沿社正在开放观察员席位，以让更多尚未获得会员资格的伙伴，
          br
          | 有机会获得更深入的分享，也获得参与前沿社部分深度讨论的旁听机会。
  .container.min
    .entry-subhead
      h3 CONDITIONS OF ENTRY
      h3.cn 申请条件
    .entry-list.special
      ul
        li <b>推　荐：</b>每位申请人需要被一位前沿社会员或行业领军人物推荐
        li <b>资　格：</b>申请人须为企业创始人、联合创始人；企业高管包括 CEO、CTO 或 COO
        li <b>审　核：</b>前沿社联合发起人享有最终会员资格审核权
        li <b>会员费：</b>10 万人民币/年

  .container.min
    .entry-subhead
      h3 MEMBERSHIP BENEFITS
      h3.cn 会员权益
    .entry-list
      ul
        li 与全球 TOP20 知名学府、科研机构权威专家交流资格*
        li 可报名全年的近场研究Field Study 闭门交流
        li 优先参与极客公园主办的海外超频之旅活动，享受优惠*
        li 免费参与前沿社组织的其他高端闭门交流机会
      p.notes * 将根据Membership权益不同略有调整

  .container.min
    .entry-subhead
      h3 SCHOLARSHIP APPLICATION
      h3.cn 奖学金申请
    .entry-list
      ul
        li 前沿社对早期创业公司特设奖学金机制
        li 经过机构推荐，B轮之前阶段优秀公司创始人可申请前沿社奖学金
        li 经过评审考核，前沿社将给予价值7万元的专项奖学金
  .container
    .entry-subhead
      h3 RECOMMENDER
      h3.cn 推荐人
    .recommender-list
      ul
        li.recommender-item(v-for="(item, $index) in recommender.items")
          p.name {{item.name}}
          p.company {{item.company}}
          p.position(v-html="item.position")
    .tips * 除以上推荐人外前沿社会员也具备推荐资格
</template>

<script>
export default {
  name: 'intro',
  data() {
    return {
      link: 'http://cn.mikecrm.com/J6cZ7QZ'
    }
  },
  computed: {
    recommender() {
      return this.$store.state.config['recommender']
    },
  }
}
</script>

<style lang="stylus">
@import '../assets/css/var'

.entry
  padding-bottom 100px
  .container.min
    max-width 640px
  .cover
    background #161616
    color #fff
    padding 80px 0
    h1
      font-size 65px
      margin-bottom 30px
      text-align center
      font-family 'FZLTTHCJW--GB1-0'
      letter-spacing 8px
    .guide
      display flex
      flex-flow row nowrap
      justify-content space-between
      counter-reset section
      li
        position relative
        display inline-block
        width 240px
        text-align left
        padding-left 45px
        padding-top 50px
        &::before
          position absolute
          counter-increment section
          content counter(section)
          font-size 150px
          font-family 'BebasNeue'
          color #747474
          left 0
          top 0

        .title
          position relative
          border-right 2px solid #fff
          h3
            display inline-block
            font-family 'BebasNeue'
            font-size 50px
            text-transform uppercase
            vertical-align middle
            line-height 1em
            &.cn
              font-size 60px
              font-family 'FZLTTHCJW--GB1-0'
              letter-spacing 4px
              width auto
        p
          padding-right 20px
          position relative
          font-size 12px
          line-height 1.4em

    .link
      margin-top 40px
      text-align center
      a
        color #5EC5FF
        display inline-block
        border 0.1em solid currentColor
        padding 0.5em 2em
        font-size 24px
        font-weight bolder
        &:hover
          color #000
          background-color #5EC5FF
          border-color #5EC5FF
    .observer-link
      color #5EC5FF
      margin-top 3em
      display inline-block
    .links
      display flex
      justify-content space-around
      max-width 800px
      margin-left auto
      margin-right auto
      @media $media
        a
          border 0.08em solid currentColor
          padding 0.5em 0.5em
  .entry-subhead
    text-align center
    margin 70px 0 40px
    h3
      display inline-block
      color #C0C0C0
      font-family 'BebasNeue'
      font-size 30px
      text-transform uppercase
      vertical-align middle
      margin-right 0.3em
      width 5em
      text-align right
      line-height 0.9em
      &.cn
        font-size 56px
        font-family 'FZLTTHCJW--GB1-0'
        letter-spacing 4px
        width auto
  .entry-list
    li
      position relative
      font-size 16px
      padding-left 1em
      line-height 1.5em
      &::before
        content ''
        position absolute
        left 0
        top 0.6em
        width 4px
        height 4px
        background #ddd
        overflow hidden
    &.special
      li
        b
          font-weight bold
          margin-left -4em
        padding-left 5em
    .notes
      margin .5em 0 0 1em
      font-size 14px
      color #C0C0C0
  .recommender-list
    margin-bottom 30px
    .recommender-item
      position relative
      display inline-block
      width 25%
      margin-bottom 20px
      padding-left 1em
      box-sizing border-box
      vertical-align top
      &::before
        content ''
        position absolute
        left 0
        top 0.6em
        width 4px
        height 4px
        background #ddd
        overflow hidden
      .name
        font-size 16px
        font-weight bold
      .company
        font-size 14px
        line-height 2em
      .position
        font-size 12px
        color #979797
  .tips
    font-size 14px
    text-align center
    color #666
@media $media
  .entry
    .cover
      padding 40px 0
      h1
        font-size 48px
        margin-bottom 15px
        letter-spacing 4px
      .guide
        li
          width 30%
          padding-left 0px
          padding-top 40px
          &::before
            font-size 100px
          .title
            border-right 1px solid #fff
            h3
              font-size 18px
              &.cn
                font-size 20px
                letter-spacing 4px
          p
            padding-right 0.5em
            font-size 12px
            line-height 1.4em

      .link
        margin-top 25px
        a
          font-size 20px

    .entry-subhead
      margin 50px 0 20px
      h3
        font-size 22px
        &.cn
          font-size 38px
          letter-spacing 0px
    .entry-list
      li
        font-size 14px
      .notes
        font-size 12px
    .recommender-list
      .recommender-item
        width 33%
    .position
      color #979797
</style>



// WEBPACK FOOTER //
// Entry.vue?6091b321